var l = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {};
function t(o) {
  return o && o.__esModule && Object.prototype.hasOwnProperty.call(o, "default") ? o.default : o;
}
export {
  l as commonjsGlobal,
  t as getDefaultExportFromCjs
};
//# sourceMappingURL=index.es469.js.map
